import { Fragment, useRef } from "react";
import { getImgxUrl } from "@crehana/utils";
import cn from "classnames";
import { USER_MENU_AVATAR_TOUR_ID } from "../../constants";
import { useMainMenuContext } from "../../hooks";
import UserMenuDesktopPopper from "./layout/UserMenuDesktopPopper";
import UserMenuMobileDrawer from "./layout/UserMenuMobileDrawer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserMenu = function UserMenu() {
  var _useMainMenuContext = useMainMenuContext(),
    themeName = _useMainMenuContext.themeName,
    loadingMe = _useMainMenuContext.loadingMe,
    me = _useMainMenuContext.me,
    currentBreakpointKey = _useMainMenuContext.currentBreakpointKey,
    layoutConfig = _useMainMenuContext.layoutConfig,
    activeSubMenu = _useMainMenuContext.activeSubMenu,
    onToggleSubmenu = _useMainMenuContext.onToggleSubmenu,
    onCloseSubmenu = _useMainMenuContext.onCloseSubmenu;
  var userMenuAvatarRef = useRef(null);
  if (loadingMe || me.isAnonymous || layoutConfig.hideUserMenu) {
    return null;
  }
  var userMenuIsOpen = activeSubMenu === 'user-menu';
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: function onClick() {
        return onToggleSubmenu('user-menu');
      },
      className: "flex items-center justify-center p-8 ml-4 -mr-8 sm:ml-8",
      ref: userMenuAvatarRef,
      "data-tour": USER_MENU_AVATAR_TOUR_ID,
      children: /*#__PURE__*/_jsx("img", {
        src: getImgxUrl(me.profilePictureUrl || '', {
          auto: 'format',
          crop: 'faces',
          dpr: 2,
          h: 32,
          w: 32,
          fit: 'crop'
        }),
        alt: me.username || 'profile',
        className: cn('rounded-full', themeName.submenu === 'dark' ? 'bg-gray-main-dark-mode' : 'bg-gray-lighter'),
        height: 32,
        width: 32,
        decoding: "async"
      })
    }), currentBreakpointKey === 'xs' || currentBreakpointKey === 'sm' ? /*#__PURE__*/_jsx(UserMenuMobileDrawer, {
      isOpen: userMenuIsOpen,
      onDismiss: onCloseSubmenu
    }) : /*#__PURE__*/_jsx(UserMenuDesktopPopper, {
      userMenuAvatarRef: userMenuAvatarRef,
      isOpen: userMenuIsOpen,
      onDismiss: onCloseSubmenu
    })]
  });
};
export default UserMenu;